import React from 'react';

const partners = [
  { name: 'Health First', logo: 'Health First' },
  { name: 'Parrish Medical Center', logo: 'Parrish Medical' },
  { name: 'Holmes Regional', logo: 'Holmes Regional' },
  { name: 'Brevard Surgery Center', logo: 'Brevard Surgery' },
];

export const PartnersSection = () => {
  return (
    <section className="py-16 bg-card border-y border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Partners */}
        <div className="text-center">
          <h3 className="font-display text-xl font-semibold text-foreground mb-8">
            Our Healthcare Partners
          </h3>
          <div className="flex flex-wrap justify-center items-center gap-8 lg:gap-16">
            {partners.map((partner) => (
              <div 
                key={partner.name}
                className="px-6 py-3 bg-muted rounded-lg text-muted-foreground font-semibold text-sm hover:bg-primary/10 hover:text-primary transition-colors"
              >
                {partner.logo}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
